import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ContractCustomerScreen, none } from './contractCustomerScreen';


interface ContractCustomerState {
    viewModel: ContractCustomerScreen.ViewModel,
}



const initialState: ContractCustomerState = {
    viewModel: none()

}

export const contractCustomerSlice = createSlice({
    name: 'contractCustomer',
    initialState,
    reducers: {
        setViewModel: (state, action: PayloadAction<ContractCustomerScreen.ViewModel>) => {
            // eslint-disable-next-line no-console
            console.log('ContractCustomerScreen: setViewModel')
            state.viewModel = action.payload
        },
    }
})

export const { setViewModel } = contractCustomerSlice.actions


export default contractCustomerSlice.reducer